"use client";

import { useMemo, useRef } from "react";
import ReactECharts from "echarts-for-react";
import type EChartsReact from "echarts-for-react";
import {
  buildPamiPolarOption,
  buildPamiSeriesData,
  PAMI_SERIE_TRAITS,
} from "@repo/pami";

export function PamiChart({ scores }: { scores: Record<string, number> }) {
  const chartRef = useRef<EChartsReact>(null);
  const option = useMemo(() => buildPamiPolarOption(scores), [scores]);

  // Le filtrage par la légende rejoue un sous-ensemble des mêmes items : on
  // reconstruit la liste complète pour pouvoir la filtrer.
  const seriesData = useMemo(() => buildPamiSeriesData(scores), [scores]);

  const onEvents = useMemo(
    () => ({
      legendselectchanged: (params: { selected: Record<string, boolean> }) => {
        const instance = chartRef.current?.getEchartsInstance();
        if (!instance) return;
        const filtered = seriesData.filter(
          (item) => params.selected[item.region] !== false,
        );
        instance.setOption({
          series: [{ name: PAMI_SERIE_TRAITS, data: filtered }],
        });
      },
    }),
    [seriesData],
  );

  return (
    <ReactECharts
      ref={chartRef}
      option={option}
      notMerge
      style={{ width: "100%", height: "clamp(400px, 60vw, 720px)" }}
      onEvents={onEvents}
    />
  );
}
